export default __webpack_public_path__ + "static/media/loja5.7b3ccdd3.jpeg";